import ScriptPage from '@/views/pages/script/ScriptPage.vue';
import { RouteRecordRaw } from 'vue-router';
import { validateIdAsPositiveIntegerGuard } from '../routeGuards';
import { FormAction } from '@/types';
import ScriptFormPage from '@/views/pages/script/ScriptFormPage.vue';
import ScriptDetailPage from '@/views/pages/script/ScriptDetailPage.vue';

const scriptRouter: RouteRecordRaw = {
    name: 'Script',
    path: 'scripts',
    children: [
        {
            name: 'ListScript',
            path: '',
            component: ScriptPage,
        },
        {
            name: 'ViewScriptById',
            path: ':id',
            component: ScriptDetailPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            meta: { isLevelLocked: true },
        },
        {
            name: 'EditScriptById',
            path: ':id/edit',
            component: ScriptFormPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard],
            props: { action: FormAction.EDIT },
            meta: { isLevelLocked: true },
        },
        {
            name: 'CreateScript',
            path: 'create',
            component: ScriptFormPage,
            props: { action: FormAction.CREATE },
            meta: { isLevelLocked: true },
        },
    ],
};

export default scriptRouter;
